import { css } from '@emotion/react'
import React, { SyntheticEvent, FC, useRef } from 'react'
import { ButtonOutline } from 'front-end/src/components'

export interface IUploadProps {
  title: string
  accept?: string
  id?: string
  onChange?: (e: SyntheticEvent<HTMLInputElement>) => void
  isLoading?: boolean
  icon?: React.ReactElement
  isFullWidth?: boolean
}

export const Upload: FC<IUploadProps> = (props) => {
  const {
    title,
    accept,
    onChange,
    isLoading,
    icon,
    id,
    isFullWidth,
    ...restProps
  } = props
  const inputRef = useRef<HTMLInputElement>(null)
  let idForChildren = id
  if (!idForChildren) {
    idForChildren = Math.random() //random string
      .toString(36)
      .slice(6)
  }
  return (
    <div className="Upload" {...restProps}>
      <ButtonOutline
        display="block"
        textOverflow="ellipsis"
        overflow="hidden"
        whiteSpace="nowrap"
        maxW="100%"
        padding={['8px 12px', '10px 24px']}
        leftIcon={icon && icon}
        onClick={() => {
          inputRef.current && inputRef.current.click()
        }}
        isLoading={isLoading}
        isFullWidth={isFullWidth}
      >
        {title}
      </ButtonOutline>
      <input
        css={css`
          display: none;
        `}
        title={title}
        type="file"
        id={idForChildren}
        accept={accept}
        ref={inputRef}
        onChange={onChange}
      />
    </div>
  )
}
